import { useState } from "react";
import profile from "../assets/Profile.jpg";
import "../App.css";

const fullText = `Welcome to thechiro! I'm Dr. Zaiq Rana, a passionate chiropractor dedicated to helping and healing people through my extensive knowledge of anatomy and the body's natural ability to recover. My journey into chiropractic care was fueled by a deep fascination with the human body and its incredible ability to heal and perform.

This interest guided me to earn a Bachelor's degree in Kinesiology from the University of Western Ontario, where I excelled academically and expanded my knowledge through an exchange program at Victoria University in Melbourne, Australia.

In addition to my academic achievements, I had the privilege of serving as an assistant coach for the varsity women's field hockey team at Western. This experience, combined with my background as an elite athlete representing Canada on the Men's Junior National Field Hockey Team, has given me a unique perspective on the physical and mental demands of high-level sports. My time as both a coach and athlete deepened my understanding of injury prevention, recovery, and the importance of maintaining peak physical condition.

Before earning my Doctor of Chiropractic degree from the Canadian Memorial Chiropractic College, I gained practical experience as a Certified Personal Training Specialist, working closely with clients to help them achieve their fitness goals. This hands-on experience reinforced my belief in the critical connection between physical fitness and overall well-being.

At thechiro, I am committed to providing personalized care tailored to each patient's unique needs. Whether you're an athlete looking to enhance performance, someone recovering from an injury, or simply striving for better overall wellness, my goal is to help you achieve optimal health. I look forward to partnering with you on your journey to a healthier, more active life!

Experience and Current Work
I am currently practicing at Synergy Chiropractic & Sports Therapy, located at 1160 Burrard St Suite #404, Vancouver, BC V6Z 2E8. My work here focuses on providing comprehensive chiropractic care tailored to meet the unique needs of each patient. I am certified in Instrument Assisted Soft Tissue Mobilization (IATSM) therapy, utilizing the Kazemizer shark tool to effectively treat soft tissue injuries and promote healing.

In addition to my chiropractic expertise, I am also a certified personal trainer, which allows me to integrate fitness and rehabilitation into my treatment plans. My aim is to help you achieve optimal health and wellness, whether you're recovering from an injury, looking to enhance your athletic performance, or striving for better overall health.`;

const badges = [
  { label: "Doctor of Chiropractic" },
  { label: "Certified Personal Trainer" },
  { label: "Canada National Athlete" },
  { label: "IASTM Certified" },
];

const Home = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="flex flex-col flex-1 page-fade-in">
      {/* Very subtle background texture */}
      <div className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(200,150,31,0.04) 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto w-full flex flex-col md:flex-row items-center gap-10 lg:gap-16 px-6 py-12 md:py-16">

        {/* ── Left: Image ── */}
        <div className="flex flex-col items-center md:items-end gap-8 w-full md:w-5/12 flex-shrink-0">

          {/* Name */}
          <div className="text-center md:text-right w-full">
            <h1 className="text-6xl md:text-7xl font-bold tracking-tight leading-none text-white">
              ZAIQ
            </h1>
            <h1
              className="text-6xl md:text-7xl font-bold tracking-tight leading-none gold-glow-text"
              style={{ color: "#c8961f" }}
            >
              RANA
            </h1>
            <p className="mt-3 text-white/30 text-xs tracking-[0.25em] uppercase font-light">
              Doctor of Chiropractic
            </p>
          </div>

          {/* Profile photo */}
          <div className="relative w-full max-w-[300px]">
            {/* Gold ambient glow behind image */}
            <div
              className="absolute inset-0 rounded-2xl pointer-events-none blur-2xl scale-95 opacity-10"
              style={{ background: "radial-gradient(ellipse, #c8961f 0%, transparent 70%)" }}
            />
            <div className="glass-card p-[3px] rounded-2xl relative overflow-hidden"
              style={{ borderColor: "rgba(200,150,31,0.18)" }}>
              <img
                src={profile}
                alt="Dr. Zaiq Rana"
                className="w-full h-auto object-cover rounded-[14px]"
                style={{ maxHeight: "420px", objectFit: "cover" }}
              />
            </div>
          </div>

          {/* Credential badges */}
          <div className="flex flex-wrap justify-center md:justify-end gap-2 w-full max-w-[300px]">
            {badges.map((b) => (
              <span
                key={b.label}
                className="text-[0.68rem] px-2.5 py-1 rounded-full font-medium tracking-wide"
                style={{
                  background: "rgba(200,150,31,0.08)",
                  border: "1px solid rgba(200,150,31,0.2)",
                  color: "rgba(212,170,69,0.85)",
                }}
              >
                {b.label}
              </span>
            ))}
          </div>
        </div>

        {/* ── Right: Bio ── */}
        <div className="w-full md:w-7/12 flex flex-col gap-5">
          <div className="glass-card p-6 md:p-8 rounded-2xl" style={{ borderColor: "rgba(255,255,255,0.07)" }}>
            <span className="section-label">About</span>

            {/* Text — mask-image fades the text itself, not a box overlay */}
            <div className="relative mt-4">
              <div
                className={`h-[220px] text-white/65 text-sm leading-relaxed whitespace-pre-line pr-1 transition-opacity duration-300 ${
                  showMore ? "overflow-y-scroll custom-scrollbar" : "overflow-hidden"
                }`}
                style={{
                  WebkitMaskImage: showMore
                    ? "none"
                    : "linear-gradient(to bottom, black 52%, transparent 100%)",
                  maskImage: showMore
                    ? "none"
                    : "linear-gradient(to bottom, black 52%, transparent 100%)",
                }}
              >
                {fullText}
              </div>

              {/* Button — slides down and fades out on click */}
              <div
                style={{
                  maxHeight: showMore ? "0px" : "52px",
                  opacity: showMore ? 0 : 1,
                  transform: showMore ? "translateY(10px)" : "translateY(0)",
                  overflow: "hidden",
                  paddingTop: "10px",
                  transition: "max-height 0.45s ease, opacity 0.35s ease, transform 0.35s ease",
                }}
              >
                <button onClick={() => setShowMore(true)} className="btn-gold">
                  Read More
                </button>
              </div>
            </div>
          </div>

          {/* CTA */}
          <a
            href="/contact"
            className="block text-center py-3.5 px-6 rounded-xl text-sm font-semibold tracking-wider transition-all duration-200"
            style={{
              background: "rgba(200,150,31,0.1)",
              border: "1px solid rgba(200,150,31,0.3)",
              color: "#d4aa45",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = "rgba(200,150,31,0.18)";
              e.currentTarget.style.borderColor = "rgba(200,150,31,0.55)";
              e.currentTarget.style.color = "#f0d070";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = "rgba(200,150,31,0.1)";
              e.currentTarget.style.borderColor = "rgba(200,150,31,0.3)";
              e.currentTarget.style.color = "#d4aa45";
            }}
          >
            Book an Appointment →
          </a>
        </div>

      </div>
    </div>
  );
};

export default Home;
